import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import '../../styles/boat/BoatEmptyImagePlaceholder.css';

const BoatEmptyImagePlaceholder = () => {
    return (
        <div className="boat-empty-image-placeholder">
            <FontAwesomeIcon icon={faImage} />
        </div>
    );
};

export default BoatEmptyImagePlaceholder;
